//
//
//
//
//
//

export default {
  name: 'DpTableHead',
};
